import localforage from 'localforage';

const imageStore = localforage.createInstance({
    name: 'Frontm_Platform',
    storeName: 'Images',
});


export const setImageFile = (imgKey, imgFileBlob) => {
    return imageStore.setItem(imgKey, imgFileBlob);
};

export const getImageFile = async (imgKey) => {
    try {
        return await imageStore.getItem(imgKey);
    } catch (error) {
        console.error(`Failed to retrieve image with key ${imgKey}`, error);
        return null;
    }
};

export const clearImgStore = async () => {
    try {
        await imageStore.clear();
    } catch (error) {
        console.error('Failed to clear image store', error);
    }
};